import React from 'react'

import { StatusBanner } from '../styles'

export type RfStatusTone = 'success' | 'warning' | 'error' | 'info'

interface RfStatusBannerProps {
  tone: RfStatusTone
  children: React.ReactNode
}

export const RfStatusBanner = ({ tone, children }: RfStatusBannerProps) => (
  <StatusBanner $tone={tone} role={tone === 'error' ? 'alert' : 'status'}>
    {children}
  </StatusBanner>
)
